export default __webpack_public_path__ + "static/beep-c40759abda1489ef87a5058726ace612.mp3";